<div class="offcanvas-header p-3 border-bottom">
  <h2 class="text-1 m-0 d-flex gap-2 align-items-center pl-3">
    {{ 'Dash.Notifications' | translate }}
  </h2>
  <button type="button" class="color-1 btn" (click)="closeDrawer()">
    <b>✕</b>
  </button>
</div>
<div
  class="offcanvas-body p-0 max-width-drawer notification_drawer_body"
  (scroll)="onNotificationScroll($event)"
>
  @if (listingNotificationAll?.length > 0) {
    <div class="text-center border-bottom mark_all_as_read">
      <a href="javascript:void(0)" (click)="notificationReadAll()">
        <i class="fa fa-check" aria-hidden="true"></i>
        {{ 'Mark all as read' | translate }}
      </a>
    </div>
  }
  <div class="p-3 pb-3 mb-4">
    @for (
      notification of listingNotificationAll;
      track trackByNotification($index, notification)
    ) {
      <div
        (click)="$event.preventDefault(); notificationRead(notification)"
        [ngClass]="{ notificationRead: notification.is_read != true }"
        class="d-flex align-items-center p-2 border-bottom"
        style="cursor: pointer"
      >
        @if (notification.module == 'csv_upload') {
          <i class="fas fa-upload fs-4 text-center" style="width: 31px"></i>
        }
        @if (notification.module != 'csv_upload') {
          <i class="fas fa-clock fs-4 text-center" style="width: 31px"></i>
        }
        <span class="pl-2">
          @if (
            (notification.module !== 'eQuote_module' || !isNewQuoteRequest(notification.description)) &&
            hasEmbeddedLink(notification.description)
          ) {
            <p class="text-dark word-break">
              {{ getTranslatedNotificationText(notification.description) }}
              <a
                href="javascript:void(0)"
                (click)="
                  $event.preventDefault();
                  $event.stopPropagation();
                  notificationRead(notification)
                "
                style="
                  color: #007bff;
                  text-decoration: underline;
                  cursor: pointer;
                "
                >{{ 'COMMON.Click' | translate }}</a
              >
            </p>
          }
          @if (
            (notification.module !== 'eQuote_module' || !isNewQuoteRequest(notification.description)) &&
            !hasEmbeddedLink(notification.description)
          ) {
            <p
              class="text-dark word-break"
              [innerHtml]="
                translateNotificationDescription(notification.description)
                  | notificationSafeHtml
              "
              (click)="
                $event.preventDefault();
                $event.stopPropagation();
                notificationRead(notification)
              "
            ></p>
          }
          @if (notification.module == 'eQuote_module' && isNewQuoteRequest(notification.description)) {
            <p
              class="text-dark word-break"
              (click)="
                $event.preventDefault();
                $event.stopPropagation();
                notificationRead(notification)
              "
            >
              {{ 'Dash.New_Quote_request' | translate }}
              <span
                [innerHtml]="notification.description | notificationSafeHtml"
              ></span>
            </p>
          }
          @if (notification.timeago) {
            <span
              class="tags bg-light-primary color-1 p-1 rounded text-sm font-medium"
              >{{ translateTimeago(notification.timeago) }}</span
            >
          }
        </span>
      </div>
    }
    @if (loadingNotificaitonsAll) {
      <div class="text-center p-3">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    }
    @if (!hasMoreNotificationsAll && listingNotificationAll?.length > 0) {
      <div class="text-center p-3 text-muted">
        {{ 'Dash.No_New_Notifications' | translate }}
      </div>
    }
  </div>
</div>
